import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Components
import { LandingComponent } from './components/landing/landing.component';
import { CallbackComponent } from './components/callback/callback.component';

/**
 * Auth Module Routes
 *
 * Defines routes for authentication-related pages:
 * - /auth/landing - Landing page with login button
 * - /auth/callback - OAuth2 callback handler
 */
const routes: Routes = [
  {
    path: 'landing',
    component: LandingComponent
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
